<template>
  <div id="app" :class="{flex_box:!isMobile}">
    <div :class="{app_box:widthStyle}">
      <router-view />
    </div>
  </div>
</template>

<script>
import { getWxSignature } from './utils/wxjssdk'

export default {
  data() {
    return {
      pcPageFlag: false, //判断是否是pc端样式页面
    }
  },
  computed: {
    //判断是手机端还是pc端
    isMobile: function(){
      if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
        this.$store.commit('equipment/isMobile', true)
        return true; // 移动端
      }else{
        this.$store.commit('equipment/isMobile', false)
        return false; // PC端
      }
    },
    widthStyle: function(){ //判断是否需要加固定宽度、高度
      const flag = !this.isMobile && !this.pcPageFlag
      this.$store.commit('equipment/widthStyle', flag)
      this.$store.commit('equipment/height', flag ? {'height':'100%'} : {'height':'100vh'} )
      return flag
    }
  },
  mounted: function() {
    if(this.isMobile) { return false }
    document.documentElement.style.fontSize = 37.5 + 'px'
    window.addEventListener('resize',function() {
      if(Number.parseInt(document.documentElement.style.fontSize) > 37.5){
        document.documentElement.style.fontSize = 37.5 + 'px'
      }
    })
  },
  watch: {
    $route: function(value) {
      const omitList = ['/phones','/login/redirect'];
      if (!omitList.includes(value.path)) {
        getWxSignature(value);
      }
      const isNeedLogin = this.checkIfLogin();
      if (isNeedLogin) {
        this.doWxLogin();
      }

      // pc页面
      const pcPageFlag = [
        '/batchSignUp',
        '/namesign',
        '/exam/dynamic',
        '/resultmore',
        '/grade',
        '/examList',
        '/examRoomPlan',
        '/associationAudit',
        '/userManage'
      ]
      this.pcPageFlag = pcPageFlag.includes(value.path)
      this.$store.commit('equipment/pcPageFlag', this.pcPageFlag)
    },
    '$store.state.session.login': function() {
      const isNeedLogin = this.checkIfLogin();
      if (isNeedLogin) { 
        this.doWxLogin();
      }
    },
    '$store.state.session.login': function(value) {
      if (!value) {
        this.$dialog.confirm({
          title: '提示',
          message: '登录已失效，请重新登录！',
          showCancelButton: false,
          confirmButtonColor: '#54B0FB',
          confirmButtonText:'确定',
        }).then(() => {
          this.$router.push('/phones')
        })
      }
    }
  },
  methods: {
    getWxAppId() {
      return new Promise((revolve)=>{
        this.$http.get('/auth/appId', { //获取appId
          params: { url: location.href } 
        }).then(res => {
          if(res.data.success){
            revolve(res.data.msg)
          }
        })
      })
    },
    checkIfLogin: function() {
      if (this.$route.meta.omitLogin) {
        return false;
      } else {
        return !this.$store.state.session.login;
      }
    },
    doWxLogin: async function() {
      if (!this.$utilsUA.isWeixin) return
      let wxAppId = await this.getWxAppId()
      const url =`${this.$server.wxLogin}?appid=${wxAppId}&redirect_uri=${encodeURIComponent(this.$server.wxRedirectUrl)}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
      window.location.replace(url);
    },
  },
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
  font-size: 30px;
  color: @apcolor;
  background-color: #FAFAFA;
}
.flex_box{
  display: flex;
  justify-content: center;
}
.app_box{
  width: 375PX;
  height: 667PX;
}
</style>
